var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"seller-manager"},[_c('SellerLeft'),_vm._v(" "),(_vm.sellingComponent === 'sdk')?_c('SDKDownload'):(_vm.sellingComponent === 'resist')?_c('ResistContents'):(_vm.sellingComponent === 'contents')?_c('SellingContents'):(_vm.sellingComponent === 'revenue')?_c('Revenue'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8bfb637c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/SellerManager.vue
// module id = 225
// module chunks = 0